(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/init.js');
"use strict";

const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  selectSportEvent,
  selectLeagueFromSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useSelector
} = ReactRedux;
const {
  getIsOngoing,
  getSportInfoMatchState,
  getIsFinished
} = svs.components.sportinfo.common.matchState;
const {
  getStatusTextBySportEventAndLeague
} = svs.components.sportinfo.sportConfig.helpers;
const {
  statusTexts
} = svs.components.sportinfo.sportConfig.sports.Default;
const {
  SportEventStatus
} = svs.components.sport.sportEventCommon;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  useEffect,
  useState,
  useRef,
  useCallback
} = React;
const {
  MatchResultTypes
} = svs.components.sport.tipsenShared.constants;
const {
  Result
} = svs.components.tipsen.couponStatic;
const getMatchStatusClass = sportEventStatus => {
  switch (sportEventStatus) {
    case SportEventStatus.Postponed:
    case SportEventStatus.Cancelled:
      return 'canceled';
    default:
      return getSportInfoMatchState(sportEventStatus);
  }
};
const statusTextsShortToFull = (matchStatus, isSmall) => {
  switch (matchStatus) {
    case statusTexts.Cancelled.short:
      return statusTexts.Cancelled.full;
    case statusTexts.Postponed.short:
      return isSmall ? statusTexts.Postponed.short : statusTexts.Postponed.full;
    default:
      return matchStatus;
  }
};
const Init = _ref => {
  var _getMatchStatusClass;
  let {
    drawEvent,
    drawNumber,
    productId,
    isCompressed,
    isResultPage
  } = _ref;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const shouldShowResultText = isResultPage || !(isCompressed && isExtraSmall);
  const {
    data
  } = useDrawResults({
    productId,
    drawNumber
  });
  const [currentDrawResult] = data;
  const eventNumber = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber) || undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const league = useSelector(state => selectLeagueFromSportEvent(state, currentMatchId));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const [matchStatusText, setMatchStatusText] = useState(() => statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league), isSmall));
  const isFinished = currentDrawResult ? currentDrawResult[eventNumber - 1].matchResultState >= MatchResultTypes.VERIFIED : false;
  const isOngoing = !isFinished && sportEvent ? getIsOngoing(sportEvent.sportEventStatus) || getIsFinished(sportEvent.sportEventStatus) : undefined;
  const stopIntervalFunctionRef = useRef();
  const startTimer = useCallback(() => {
    if (isFinished) {
      setMatchStatusText('FT');
      return;
    }
    setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
    if (!isOngoing) {
      return;
    }
    stopIntervalFunctionRef.current = setInterval(() => {
      setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
    }, 1000);
  }, [isFinished, isOngoing, league, sportEvent]);
  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      return undefined;
    } else if (stopIntervalFunctionRef.current) {
      clearInterval(stopIntervalFunctionRef.current);
      startTimer();
    }
  }, [startTimer]);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
  useEffect(() => {
    startTimer();
    return () => {
      if (stopIntervalFunctionRef.current) {
        clearInterval(stopIntervalFunctionRef.current);
      }
    };
  }, [isOngoing, isFinished, sportEvent, league, startTimer]);
  return React.createElement("div", {
    className: "pg_coupon_static__init"
  }, matchStatusText && shouldShowResultText && React.createElement("div", {
    className: "pg_coupon_static__init__text pg_coupon_static__init__text--".concat(isFinished ? 'finished' : (_getMatchStatusClass = getMatchStatusClass(sportEvent.sportEventStatus)) === null || _getMatchStatusClass === void 0 ? void 0 : _getMatchStatusClass.toLowerCase())
  }, matchStatusText), React.createElement(Result, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.couponStatic.Init', Init);

 })(window);